/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Alt_HintInputs */

const vi_media_alt_hint = /** @type {(inputs: Media_Alt_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả ngắn nội dung ảnh, dùng cho người khiếm thị và Google. Ví dụ: Đồi chè Tân Cương buổi sáng.`)
};

/**

* @param {Media_Alt_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_alt_hint = /** @type {((inputs?: Media_Alt_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Alt_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_alt_hint(inputs)
});